import { combineReducers } from "redux";
import IndexReducer from './IndexSlice';
export default combineReducers({
    Index: IndexReducer
})